import styled from 'styled-components'

export const Container = styled.div`
  background: rgba(32, 32, 32, 0.8);
  box-shadow: rgb(0 0 0 / 10%) 0 2px 16px;
  backdrop-filter: blur(1rem);
  border-radius: 0.5rem;
  color: white;
  position: absolute;
  width: 13.25rem;
  height: auto;
  z-index: 3;
  text-align: left;
  padding: 1rem 1.5rem 1.5rem;
  transition: all 0.3s ease 0s;
  right: 3.75rem;
  top: 0.875rem;

  p {
    margin: 0;
  }
`
export const Buttons = styled.div`
  display: flex;
  gap: 0.75rem;
  align-items: center;
  justify-content: space-between;
  margin-top: 1rem;
`
export const Button = styled.button`
  background: rgba(255, 255, 255, 0.25);
  border-radius: 0.375rem;
  padding: 0.438rem 1.688rem;
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1.125rem;
  text-align: center;
  color: white;
  border: none;
  cursor: pointer;
`



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/components/PopUp/PopUp.style.tsx